import type { CachedContentData } from '@/hooks/useCachedContentData';

/** The three resolved images a FEATURED card can fall back through — nothing else is read. */
export type FeaturedBackdropSource = Pick<
    CachedContentData,
    'backdropImageURL_W1280' | 'backdropImage' | 'posterImage'
>;

/**
 * The image a FEATURED card renders behind its poster.
 *
 * `backdropImageURL_W1280` is the movie's own backdrop at the width this card needs: it is a
 * full-width 300px band on desktop, where the W780 variant `backdropImage` carries is visibly soft.
 *
 * It only exists for a content that HAS a movie, though. A cinema's own custom content has no
 * movie, so the card used to drop straight to the poster and render it zoomed in, ignoring the
 * backdrop the operator uploaded with the custom content (CIN-15338). `backdropImage` is where that
 * upload ends up — it is also what the HOME hero renders, which is why the hero showed the right
 * image all along.
 *
 * The poster stays as the last resort for a content resolved without any backdrop at all.
 */
export function getFeaturedBackdropImage(content: FeaturedBackdropSource): string | undefined {
    return content.backdropImageURL_W1280 || content.backdropImage || content.posterImage;
}
